import { createFileRoute, useParams } from '@tanstack/react-router'
import { BrandPage } from '~/components/catalog/brand-page'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/products/brand/$brandSlug')({
  component: BrandRoute,
})

function BrandRoute() {
  const { brandSlug } = useParams({
    from: '/_authenticated/$workspaceSlug/products/brand/$brandSlug',
  })
  return <BrandPage brandSlug={brandSlug} key={brandSlug} />
}
